const isTouchDevice = () => window.matchMedia('(hover: none)').matches;

const closeExpirationBadges = (except) => {
  document.querySelectorAll('[data-product-card-expiration-badge].is-open').forEach((badge) => {
    if (badge === except) return;

    badge.classList.remove('is-open');
    badge.setAttribute('aria-expanded', 'false');
  });
};

document.addEventListener('click', (event) => {
  if (!isTouchDevice()) {
    return;
  }

  const badge = event.target.closest('[data-product-card-expiration-badge]');

  if (badge) {
    event.preventDefault();
    event.stopPropagation();

    const willOpen = !badge.classList.contains('is-open');
    closeExpirationBadges(willOpen ? badge : null);
    badge.classList.toggle('is-open', willOpen);
    badge.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    return;
  }

  closeExpirationBadges();
});
